// vueApp
//window.Vue = require('vue');
import Vue from 'vue'

//Include vuex functionality.
import store from './store'
// 6-R.3: PolicyFormWizard retired — the modern editor + new-policy form replace it.
import BaaFormWizard from './components/BaaFormWizard.vue';
import BaaGuidedWizard from './components/BaaGuidedWizard.vue';
import BaaTemplateBuilder from './components/BaaTemplateBuilder.vue';


//Avoid trying to load the app if the container element doesn't exist.
if(document.getElementById('vueApp')){
    Vue.component('baa-form-wizard', BaaFormWizard);
    Vue.component('baa-guided-wizard', BaaGuidedWizard);
    Vue.component('baa-template-builder', BaaTemplateBuilder);

    const app = new Vue({
        el: '#vueApp',
        store
    });
}
